import styled from 'styled-components';

export const Container = styled.div`
  width: 460px;
  max-width: calc(100vw - 2rem);
  padding: 0.75rem 1rem 0.25rem;
  background: ${(props) => props.theme.$white};
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  text-align: left;
  max-height: 60vh;
  overflow-y: auto;

  .breakdown-header,
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .breakdown-header {
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${(props) => props.theme.$gray300};
    font-weight: 600;
    color: ${(props) => props.theme.$dark};
  }

  li {
    padding: 0.5rem 0;
    color: ${(props) => props.theme.$dark};

    & + li {
      border-top: 1px solid ${(props) => props.theme.$gray300};
    }
  }

  .breakdown-color {
    flex-shrink: 0;
    width: 10px;
    height: 10px;
    margin-right: 0.6rem;
  }

  .breakdown-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .breakdown-value {
    margin-left: 1rem;
  }
`;
